import React from 'react'
import styled from 'styled-components'

import {
  Label,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'

const Wrapper = styled.div``

const AdrRulesDontApply = (props) => {
  const {} = props

  const adrRulesDontApply = useField('adrRulesDontApply')
  const adrRulesDontApplyDescription = useField('adrRulesDontApplyDescription')

  if (!adrRulesDontApply) {
    return null
  }

  return (
    <Wrapper>
      <Label>{i18n.t('info_hazmat_hints', 'Hinweise')}</Label>
      <div className="text-success">
        <strong>{adrRulesDontApplyDescription}</strong>
      </div>
    </Wrapper>
  )
}

export default AdrRulesDontApply
